/* eslint-disable import/prefer-default-export */

import { httpGet, httpPost } from '../httpCalls';
import { saveState, loadState, setCookie } from '../../sessionStore';
import { encryptText } from '../../../utils/cookies';

export const login = (data) => httpPost('loginFrontend', data, process.env.REACT_APP_AUTH_ENDPOINT).then((value) => {
  if(!!value.passwordExpiration && value.isPasswordExpired){
    setCookie('userPermissions', encryptText(''))
    throw 'Expired';
  } else {
    setCookie('userPermissions', encryptText(JSON.stringify(value.userPermissions)));
    setCookie('organization', encryptText(value.organization));
  }
  saveState({ apiToken: value.access_token, organization: value.organization, sessionEmail: data.email });
  return value;
});

export const changePassword = (data) => httpPost('changePassword', data, process.env.REACT_APP_AUTH_ENDPOINT).then((value) => {
  return value;
});

export const isLogin = () => {
  const { apiToken } = loadState();
  return apiToken !== undefined && apiToken !== '';
};

export const logOut = () => {
  saveState({ apiToken: undefined });
};